<template>
  <div class="relative">
    <div
      class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer"
      v-if="planBenefit.privacyControl && !planBenefit.privacyControl.participantInfoCollection"
      @click="handleCheckNeedUpgradePlan()"
    ></div>
    <div class="overlay-disable-setting" v-if="!canEditPresentation"></div>
    <div class="relative flex justify-items-center align-middle" @click.capture="clickForUserNotPaid()">
      <aha-checkbox
        name="settings-collect-info"
        v-aha-emit-action
        id="settings-check-audience-admission"
        @change="handleCheckBoxAudienceAdmission"
        v-model="isShownForm"
        class="mb-3 remove-css-disable"
        :disabled="isDisableAudienceAdmisstion"
      >
        <span>
          {{ $i18nPresenter.t('Ask participants for info before they join') }}
          <span v-if="!canUseNewTooltip">
            <IconNeedUpgradePlan
              ref="iconNeedUpgradePlanComponentAudienceInfor"
              :noPermission="planBenefit.privacyControl &&
                !planBenefit.privacyControl.participantInfoCollection"
              :defaultTooltip="$i18nPresenter.t('Show an entry form for the participants to fill in upon joining.')"
              left="-200px"
              :upgradePlan="planBenefit.privacyControl.participantInfoCollection_planName"
              featureName="Audience Addmission"
              v-if="planBenefit.interactivePresentation"
            />
          </span>
          <span v-else>
            <UpgradeIcon
              ref="iconNeedUpgradePlanComponentAudienceInfor"
              :noPermission="planBenefit.privacyControl &&
                !planBenefit.privacyControl.participantInfoCollection"
              :defaultTooltip="$i18nPresenter.t('Show an entry form for the participants to fill in upon joining.')"
              :upgradePlan="planBenefit.privacyControl.participantInfoCollection_planName"
              featureName="Audience Addmission"
              v-if="planBenefit.interactivePresentation"
            />
          </span>
        </span>
      </aha-checkbox>
    </div>
    <p
      v-if="integrationPlatform !== 'GoogleSlide'"
      v-html="$i18nPresenter.t('participant_view_description', { link: reportLink })"
    >
    </p>
    <div class="mt-3 form-group" v-if="isShownForm">
      <label class="label-option flex gap-2 items-center" for="audience-admission-heading">
        {{ $i18nPresenter.t('Form heading') }}
        <span class="cursor-pointer" name="heading-tooltip">
          <aha-icon
            class="text-gray-90"
            strokeColor
            maintainColor
            name="aha-question"
            width="18"
            height="18"
            viewBox="0 0 16 16"
          />
        </span>
      </label>
      <aha-toggle-tip
        to="heading-tooltip"
        :text="$i18nPresenter.t('This will appear above the form participants see when joining.')"
      >
      </aha-toggle-tip>
      <aha-input
        :maxLength="150"
        :placeholder="$i18nPresenter.t('Your welcome line…')"
        class="mt-2 mb-4"
        id="audience-admission-heading"
        @input="handleOnInput"
        v-model="heading"
      />
      <section class="display-fields flex flex-col gap-4">
        <section class="flex justify-between items-center">
          <span> {{ $i18nPresenter.t('Add fields') }}</span>
          <AddParticipantFields
            :presentationId="presentation.id"
            :selectedFields="selectedParticipantFields"
            @create="handleCreateCustomField"
            @select="handleSelectCustomField"
          >
          </AddParticipantFields>
        </section>
        <section class="selected-fields">
          <SelectedParticipantFields
            :presentationId="presentation.id"
            :selectedFields="selectedParticipantFields"
            @update:selectedParticipantFields="updateSelectedFields"
          >
          </SelectedParticipantFields>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SettingAudienceAdmission from '@/components-v2/presentation-editor/editor-header/SettingAudienceAdmission.vue'
import SelectedParticipantFields from '@/components-v2/presentation-editor/side-right/SelectedParticipantFields.vue'
import AddParticipantFields from '@/components-v2/presentation-editor/side-right/AddParticipantFields.vue'
import { ROUTE_NAMES } from '@/constant/routes'

export default {
  components: {
    AddParticipantFields,
    SelectedParticipantFields,
  },
  extends: SettingAudienceAdmission,
  computed: {
    ...mapGetters('presentationSetting',
      [
        'participantFields',
        'selectedParticipantFields',
        'participantFieldsRequired', 'participantInfoSettings',
        'participantFieldHeading',
      ]),
    reportLink() {
      const link = this.$router.resolve({
        name: ROUTE_NAMES.PRESENTATION_REPORT,
        params: {
          id: this.presentation.id,
        },
      })

      return link.href
    },
    isShownForm: {
      get() {
        return this.participantFieldsRequired
      },
      set(value) {
        this.updateParticipantInfoFields({
          presentationId: this.presentation.id,
          updatedFields: {
            heading: this.heading,
            isAudienceAdmission: value,
          },
        })
      },
    },
    heading: {
      get() {
        return this.participantFieldHeading
      },
      set(value) {
        this.updateParticipantInfoFields({
          presentationId: this.presentation.id,
          updatedFields: {
            heading: value,
            isAudienceAdmission: this.isShownForm,
          },
        })
      },
    },
  },
  methods: {
    ...mapActions('presentationSetting', ['updateSelectedParticipantFields', 'updateParticipantInfoFields']),
    formatToSelectedFields(field) {
      return {
        id: field.id,
        required: field.required,
        hidden: field.hidden,
      }
    },
    addToSelectedField(field) {
      const updateSelectedFields = [
        ...this.selectedParticipantFields,
        field,
      ]

      // add to selected list
      this.updateSelectedParticipantFields({
        presentationId: this.presentation.id,
        fields: updateSelectedFields.map(this.formatToSelectedFields),
      })
    },
    handleCreateCustomField(field) {
      this.addToSelectedField(field)
    },
    handleSelectCustomField(field) {
      this.addToSelectedField(field)
    },
    updateSelectedFields(reorderedFields) {
      this.updateSelectedParticipantFields({
        presentationId: this.presentation.id,
        fields: reorderedFields.map(this.formatToSelectedFields),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
